import api from '../httpClient';

export const dashboard = {
  summary: () => api.get('/api/dashboard/summary/').then((response) => response.data),
};
